import React from 'react';
import { Tooltip, Icon } from '@blueprintjs/core';
import './TeachRTooltip.css';

/**
 * TeachRTooltip is a customizable tooltip component that displays help information or hints.
 * 
 * @param {string} content - The text content to display inside the tooltip.
 * @param {string} icon - The icon name from BlueprintJS to display as a clickable icon.
 * @param {string} iconColor - The color to apply to the icon.
 * @param {string} [tooltipDirection="top"] - The position of the tooltip (top, bottom, left, right).
 * @param {string} [width="auto"] - The width of the tooltip content.
 * 
 * @returns {JSX.Element} - A tooltip containing an icon with customizable text and behavior.
 */
const TeachRTooltip = ({ content, icon, iconColor, tooltipDirection = "top", width = "auto" }) => {
    return (
        <Tooltip
            content={content}
            position={tooltipDirection}
            hoverOpenDelay={800}
            compact={true}
            fill={true}
            className={`custom-tooltip ${tooltipDirection}`}
        >
            <Icon icon={icon} style={{ color: iconColor }} className="custom-icon" />
        </Tooltip>
    );
};

export default TeachRTooltip;
